import React from 'react';

const CALMING_COLORS = [
  '#4a8ccc',
  '#6c9f91',
  '#7b8fc7',
  '#d19a62',
  '#c9829b',
  '#8d78b5',
  '#4f9aaf',
  '#849b78',
  '#ef8f70',
  '#5b8def',
];

const ColorThemePicker = ({ color, onChange }) => (
  <section className="rounded-3xl border border-[#c9e1f3] bg-[#edf6fc]/80 p-5">
    <div className="mb-4">
      <h2 className="font-semibold text-[#245b86]">
        Choose your calming color
      </h2>
      <p className="mt-1 text-sm text-[#5d87a7]">
        Pick one of 10 colors or choose your own custom color.
      </p>
    </div>

    <div className="flex flex-wrap items-center gap-3">
      {CALMING_COLORS.map((preset) => (
        <button
          key={preset}
          type="button"
          onClick={() => onChange(preset)}
          aria-label={`Choose ${preset}`}
          className={`h-10 w-10 rounded-full border-4 transition hover:scale-110 ${
            color === preset
              ? 'border-[#245b86] shadow-lg'
              : 'border-white'
          }`}
          style={{ backgroundColor: preset }}
        />
      ))}

      <label
        className="flex h-10 cursor-pointer items-center gap-2 rounded-full border-2 border-white bg-white px-3 text-sm font-semibold text-[#376b92] shadow-sm"
        title="Choose a custom color"
      >
        <span
          className="h-5 w-5 rounded-full border border-[#c9e1f3]"
          style={{ backgroundColor: color }}
        />
        Custom
        <input
          type="color"
          value={color}
          onChange={(event) => onChange(event.target.value)}
          className="sr-only"
        />
      </label>
    </div>
  </section>
);

export default ColorThemePicker;